import { Card, CardContent, CardActions, Box, Typography, Chip, Button } from '@mui/material';
import { LocationOn, Phone as PhoneIcon, Visibility as VisibilityIcon, Edit as EditIcon, Delete as DeleteIcon, PowerSettingsNew as ToggleIcon } from '@mui/icons-material';

export const BranchCard = ({ branch, onView, onEdit, onDelete, onToggleStatus, selected }) => {
  return (
    <Card
      elevation={selected ? 10 : 2}
      sx={{
        borderRadius: 2,
        border: selected ? '2px solid #1976d2' : '1px solid #e0e0e0',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: '0 12px 24px rgba(0,0,0,0.10)',
          borderColor: '#1976d2',
        },
        cursor: 'pointer',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        overflow: 'hidden',
      }}
      onClick={() => onView?.(branch)}
    >
      <CardContent sx={{ pb: 1.5, flex: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', mb: 1.5, gap: 1 }}>
          <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2, flex: 1 }}>
            {branch.name}
          </Typography>
          <Chip
            label={branch.is_active ? 'Active' : 'Inactive'}
            color={branch.is_active ? 'success' : 'default'}
            size="small"
            sx={{ flexShrink: 0 }}
          />
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: 'text.secondary', mb: 0.5 }}>
          <LocationOn sx={{ fontSize: 16 }} />
          <Typography variant="body2" noWrap title={`${branch.city}, ${branch.state}`}>
            {branch.city || 'Unknown'}, {branch.state || 'Unknown'}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: 'text.secondary' }}>
          <PhoneIcon sx={{ fontSize: 16 }} />
          <Typography variant="body2" noWrap title={branch.phone}>
            {branch.phone || 'No phone'}
          </Typography>
        </Box>
      </CardContent>

      
    </Card>
  );
};
